import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import FormStepperHeader from '@atoms/FormStepperHeader';
import { JButton } from '@atoms/JButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormContainerStyled } from './user-form.styled';
import useUserMutationContext from '../../hooks/useUserMutationContext';
import UserFormDetails from '../UserFormDetails';
import UserFormRole from '../UserFormRole';
import { useEffect } from 'react';

interface Props {
  mode: 'create' | 'edit';
}

const UserForm = ({ mode }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { stepIndex, setMode, setStepIndex } = useUserMutationContext();
  useEffect(() => {
    setMode(mode);
  }, [mode]);

  return (
    <>
      <TopBar title={t(mode === 'create' ? 'NEW_USER' : 'EDIT_USER')}>
        <JButton onClick={() => navigate(Paths.UsersPage)} variant="text">
          {t('CANCEL')}
        </JButton>
      </TopBar>
      <FormContainerStyled>
        <FormStepperHeader
          onChangeStep={(value) => setStepIndex(value)}
          clickable={mode === 'edit'}
          titles={['DETAILS', 'ROLES']}
          stepIndex={stepIndex}
        />

        {stepIndex === 0 && <UserFormDetails includeFooter={true} />}
        {stepIndex === 1 && <UserFormRole includeFooter={true} />}
      </FormContainerStyled>
    </>
  );
};

export default UserForm;
